import { createContext, useContext, useMemo, type ReactNode } from 'react';

import type { DataExplorerAppearance } from './types';

const DataExplorerAppearanceContext = createContext<
  DataExplorerAppearance | undefined
>(undefined);

export function DataExplorerAppearanceProvider({
  appearance,
  children,
}: {
  appearance?: DataExplorerAppearance;
  children: ReactNode;
}) {
  return (
    <DataExplorerAppearanceContext.Provider value={appearance}>
      {children}
    </DataExplorerAppearanceContext.Provider>
  );
}

export function useDataExplorerAppearance(
  appearance?: DataExplorerAppearance,
): DataExplorerAppearance | undefined {
  const inheritedAppearance = useContext(DataExplorerAppearanceContext);
  return useMemo(() => {
    if (!appearance) return inheritedAppearance;
    if (!inheritedAppearance) return appearance;
    return {
      ...inheritedAppearance,
      ...appearance,
      slots: { ...inheritedAppearance.slots, ...appearance.slots },
      styles: { ...inheritedAppearance.styles, ...appearance.styles },
    };
  }, [appearance, inheritedAppearance]);
}
